export const IS_LOADING = 'IS_LOADING';



// WEBPACK FOOTER //
// ./src/redux/action-types/ui/preview.js